import script from "./MyReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./MyReservations.vue?vue&type=script&setup=true&lang=js"

import "./MyReservations.vue?vue&type=style&index=0&id=1420bfa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1420bfa9"]])

export default __exports__